module.exports = __webpack_public_path__ + "img/bg_trust.2ed4059b.png";